import { postFetch, getFetch } from '@/utils/request'

export function getMainCategory() {
    return getFetch('/category/queryMainCategory', {})
}

export function getIndexCategoryTreeData() {
    return getFetch('/category/getIndexCategoryTree', {})
}

export function getCategoryByParentId(id) {
    return getFetch('/category/queryCategory', {paramId: id})
}


// WEBPACK FOOTER //
// ./src/api/common/categoryApi.js